module.exports = __webpack_public_path__ + "img/w3_rocket_grey.17d088f5.png";